/**
 * Parses FAQ markdown content into structured data.
 * Expected format:
 *   ## Category Name
 *   **Q: Question?**
 *   Answer text.
 */
export function parseFaqMarkdown(markdown) {
  const items = [];
  let currentCategory = '';

  const lines = markdown.split('\n');
  let i = 0;

  while (i < lines.length) {
    const line = lines[i].trim();

    if (line.startsWith('## ')) {
      currentCategory = line.replace('## ', '').trim();
      i++;
      continue;
    }

    if (line.startsWith('**Q:') && line.endsWith('**')) {
      const question = line.replace(/^\*\*Q:\s*/, '').replace(/\*\*$/, '').trim();
      i++;

      // Collect answer lines until next Q, category, or separator
      const answerLines = [];
      while (i < lines.length) {
        const next = lines[i].trim();
        if (next.startsWith('**Q:') || next.startsWith('## ') || next === '---') break;
        if (next) answerLines.push(next);
        i++;
      }

      items.push({ category: currentCategory, question, answer: answerLines.join(' ') });
      continue;
    }

    i++;
  }

  return items;
}
